import React, { useState, useEffect } from 'react';
import { FiRefreshCw, FiX } from 'react-icons/fi';

const UpdatePrompt = () => {
  const [show, setShow] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    // 1. Kezdeti ellenőrzés betöltéskor
    const checkInitialUpdate = async () => {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration && registration.waiting) {
          setWaitingWorker(registration.waiting);
          setShow(true);
        }
      }
    };
    checkInitialUpdate();

    // 2. Eseményfigyelő a későbbi frissítésekhez
    const handleUpdate = (event) => {
      const registration = event.detail;
      if (registration && registration.waiting) {
        setWaitingWorker(registration.waiting);
        setShow(true);
      }
    };

    window.addEventListener('swUpdated', handleUpdate);
    return () => window.removeEventListener('swUpdated', handleUpdate);
  }, []);

  const onUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      waitingWorker.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#333',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
      zIndex: 9999,
      animation: 'slideUp 0.5s ease-out',
      minWidth: '300px'
    }}>
      <FiRefreshCw className="spin-animation" size={20} color="#b30000" />
      <div style={{ flex: 1, fontSize: '0.9rem', fontWeight: 'bold' }}>
        Új ArcheryNexus verzió érhető el!
      </div>
      <button
        onClick={onUpdate}
        style={{
          backgroundColor: '#b30000',
          color: 'white',
          border: 'none',
          padding: '6px 12px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '0.8rem'
        }}
      >
        Frissítés most
      </button>
      <button
        onClick={() => setShow(false)}
        style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', padding: '5px' }}
      >
        <FiX size={18} />
      </button>

      <style>{`
        @keyframes slideUp {
          from { transform: translate(-50%, 100px); opacity: 0; }
          to { transform: translate(-50%, 0); opacity: 1; }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .spin-animation {
          animation: spin 2s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default UpdatePrompt;
